
import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-hardship',
  templateUrl: './hardship.component.html',
  styleUrls: ['./hardship.component.css']
})
export class HardshipComponent {

  isNavOpen = false;

  incentives = [
    {
      title: 'GAS ASSISTANCE',
      description: 'Helping participating members with transportation expenses for work, school, appointments, and everyday needs.',
      amount: 'UP TO $50',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M6 21V5h8v16"/>
          <path d="M14 8h3l2 3v7"/>
          <circle cx="17" cy="18" r="1"/>
          <path d="M8 8h4M8 12h4"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <rect width="300" height="120" fill="#08060c"/>

          <rect x="45" y="35"
                width="48"
                height="70"
                rx="4"
                fill="#16131b"
                stroke="#ff1493"
                stroke-width="2"/>

          <rect x="56" y="45"
                width="26"
                height="18"
                rx="2"
                fill="#24202a"
                stroke="#ff1493"/>

          <path d="M62 52h14"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M93 50h25l15 15v40H93Z"
                fill="#17141d"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M118 65h15"
                stroke="#ff1493"
                stroke-width="2"/>

          <circle cx="110" cy="91"
                  r="8"
                  fill="#08060c"
                  stroke="#888"
                  stroke-width="2"/>

          <circle cx="110" cy="91"
                  r="3"
                  fill="#555"/>

          <path d="M145 100h105"
                stroke="#ff1493"
                stroke-width="2"
                opacity=".5"/>

          <text x="155"
                y="55"
                fill="#ff1493"
                font-size="16"
                font-family="Arial"
                font-weight="bold">
            GAS
          </text>

          <text x="155"
                y="78"
                fill="#ddd"
                font-size="10"
                font-family="Arial">
            FUEL SUPPORT
          </text>

        </svg>
      `
    },

    {
      title: 'FOOD ASSISTANCE',
      description: 'Grocery assistance designed to help eligible individuals and families with everyday food expenses.',
      amount: 'UP TO $200',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M5 11h14"/>
          <path d="M6 11l1 9h10l1-9"/>
          <path d="M9 11V7a3 3 0 0 1 6 0v4"/>
          <path d="M10 15h4"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="foodBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#281129"/>
              <stop offset="1" stop-color="#08070d"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#foodBg)"/>

          <path d="M55 48h190l-18 58H73L55 48Z"
                fill="#593c2d"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M80 48c5-38 135-38 140 0"
                fill="none"
                stroke="#a56d3c"
                stroke-width="8"/>

          <circle cx="95" cy="48"
                  r="22"
                  fill="#6c8d38"/>

          <circle cx="130" cy="43"
                  r="25"
                  fill="#d54855"/>

          <circle cx="170" cy="45"
                  r="22"
                  fill="#e0a42e"/>

          <circle cx="205" cy="49"
                  r="24"
                  fill="#739d42"/>

          <path d="M80 34l-8-13M94 30l-2-17"
                stroke="#6e9d3e"
                stroke-width="5"/>

          <path d="M124 24l-3-15M134 22l8-13"
                stroke="#6e9d3e"
                stroke-width="5"/>

          <path d="M70 78h160"
                stroke="#ff1493"
                opacity=".5"/>

        </svg>
      `
    },

    {
      title: 'ELECTRICITY ASSISTANCE',
      description: 'Assistance toward qualifying household electricity expenses.',
      amount: 'UP TO $150',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M13 2 5 13h6l-1 9 8-11h-6l1-9Z"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <radialGradient id="lightGlow">
              <stop offset="0" stop-color="#fff4b0"/>
              <stop offset=".25" stop-color="#ffbe35"/>
              <stop offset="1" stop-color="#26130d"/>
            </radialGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="#0b080d"/>

          <circle cx="150"
                  cy="64"
                  r="55"
                  fill="url(#lightGlow)"
                  opacity=".75"/>

          <path d="M130 64
                   c0-17 10-29 20-29
                   s20 12 20 29
                   c0 8-4 13-9 18
                   v10h-22V82
                   c-5-5-9-10-9-18Z"
                fill="#ffd45c"
                stroke="#fff1ae"
                stroke-width="2"/>

          <path d="M139 92h22M140 99h20"
                stroke="#d8a32e"
                stroke-width="5"/>

          <path d="M150 12v16
                   M105 25l10 13
                   M195 25l-10 13
                   M94 62h18
                   M206 62h-18"
                stroke="#ffcf4c"
                stroke-width="3"
                stroke-linecap="round"/>

        </svg>
      `
    },

    {
      title: 'RENT OR MORTGAGE ASSISTANCE',
      description: 'Housing assistance designed to help eligible members facing qualifying financial hardship.',
      amount: 'UP TO $1,000',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="m3 11 9-8 9 8"/>
          <path d="M5 10v10h14V10"/>
          <path d="M9 20v-6h6v6"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="homeBg"
                            x1="0" y1="0"
                            x2="0" y2="1">
              <stop offset="0" stop-color="#181525"/>
              <stop offset="1" stop-color="#07070b"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#homeBg)"/>

          <path d="M55 61 150 22l95 39"
                fill="#332634"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M76 57v51h148V57"
                fill="#4b3941"
                stroke="#ff1493"
                stroke-width="2"/>

          <rect x="96" y="69"
                width="28"
                height="25"
                fill="#ffcf73"/>

          <rect x="177" y="69"
                width="28"
                height="25"
                fill="#ffcf73"/>

          <rect x="137" y="71"
                width="27"
                height="37"
                fill="#201923"
                stroke="#ff1493"/>

          <circle cx="158"
                  cy="90"
                  r="2"
                  fill="#ff1493"/>

          <path d="M0 108h300"
                stroke="#26301e"
                stroke-width="14"/>

        </svg>
      `
    },

    {
      title: 'CAR NOTE ASSISTANCE',
      description: 'Helping eligible participating members with qualifying vehicle payment needs.',
      amount: 'UP TO $500',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M5 17h14"/>
          <path d="m6 17-1-5 2-4h10l2 4-1 5"/>
          <circle cx="8" cy="17" r="2"/>
          <circle cx="16" cy="17" r="2"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="carBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#171722"/>
              <stop offset="1" stop-color="#06070b"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#carBg)"/>

          <path d="M45 79
                   C52 61 68 53 90 50
                   L110 31
                   H190
                   L218 52
                   C236 54 248 63 254 79
                   V91
                   H45Z"
                fill="#252936"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M108 36h76l20 17h-113Z"
                fill="#101923"
                stroke="#b8c5d0"/>

          <rect x="47" y="67"
                width="18"
                height="9"
                rx="3"
                fill="#ff4d75"/>

          <rect x="233" y="67"
                width="16"
                height="9"
                rx="3"
                fill="#fff0a0"/>

          <circle cx="82" cy="91"
                  r="18"
                  fill="#08080b"
                  stroke="#888"/>

          <circle cx="218" cy="91"
                  r="18"
                  fill="#08080b"
                  stroke="#888"/>

          <circle cx="82" cy="91"
                  r="7"
                  fill="#555"/>

          <circle cx="218" cy="91"
                  r="7"
                  fill="#555"/>

        </svg>
      `
    },

    {
      title: 'ELDERLY ASSISTANCE',
      description: 'Additional assistance opportunities designed to support qualifying elderly members and households.',
      amount: 'UP TO $500',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <circle cx="9" cy="8" r="3"/>
          <circle cx="17" cy="8" r="3"/>
          <path d="M3 20v-1a5 5 0 0 1 10 0v1"/>
          <path d="M11 20v-1a5 5 0 0 1 10 0v1"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <rect width="300"
                height="120"
                fill="#171016"/>

          <circle cx="110" cy="46"
                  r="18"
                  fill="#a77d61"
                  stroke="#ff1493"/>

          <circle cx="170" cy="46"
                  r="18"
                  fill="#b68a6b"
                  stroke="#ff1493"/>

          <path d="M78 110
                   c2-36 17-48 32-48
                   s30 12 32 48"
                fill="#554258"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M158 110
                   c2-36 17-48 32-48
                   s30 12 32 48"
                fill="#70505b"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M94 40c5-18 28-21 35-2"
                fill="none"
                stroke="#d2d0d1"
                stroke-width="7"/>

          <path d="M154 40c7-17 28-18 35-1"
                fill="none"
                stroke="#e1dede"
                stroke-width="7"/>

          <circle cx="103" cy="46"
                  r="7"
                  fill="none"
                  stroke="#333"/>

          <circle cx="118" cy="46"
                  r="7"
                  fill="none"
                  stroke="#333"/>

          <path d="M110 46h2"
                stroke="#333"
                stroke-width="2"/>

        </svg>
      `
    },

    {
      title: 'MILITARY FAMILY SUPPORT',
      description: 'Additional assistance opportunities for eligible military members, veterans, and their families facing qualifying everyday or financial needs.',
      amount: 'UP TO $500',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M12 3 20 6v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3Z"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <rect width="300"
                height="120"
                fill="#0b1019"/>

          <path d="M0 20h300v14H0ZM0 48h300v14H0ZM0 76h300v14H0Z"
                fill="#8b4057"
                opacity=".65"/>

          <rect x="0"
                y="0"
                width="115"
                height="67"
                fill="#17254b"/>

          <g fill="#fff" opacity=".85">
            <circle cx="20" cy="13" r="2"/>
            <circle cx="45" cy="13" r="2"/>
            <circle cx="70" cy="13" r="2"/>
            <circle cx="95" cy="13" r="2"/>
            <circle cx="32" cy="31" r="2"/>
            <circle cx="57" cy="31" r="2"/>
            <circle cx="82" cy="31" r="2"/>
            <circle cx="20" cy="49" r="2"/>
            <circle cx="45" cy="49" r="2"/>
            <circle cx="70" cy="49" r="2"/>
            <circle cx="95" cy="49" r="2"/>
          </g>

          <circle cx="210" cy="38"
                  r="13"
                  fill="#17151a"/>

          <path d="M188 105
                   c4-42 12-55 22-55
                   s20 13 24 55Z"
                fill="#17151a"/>

          <path d="M190 55h45"
                stroke="#ff1493"
                stroke-width="2"/>

        </svg>
      `
    },

    {
      title: 'SINGLE MOTHER/FATHER SUPPORT',
      description: 'Assistance designed to help eligible single mothers and fathers with qualifying household, family, and essential living expenses.',
      amount: 'UP TO $1,000',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <circle cx="9" cy="8" r="3"/>
          <circle cx="17" cy="10" r="2.5"/>
          <path d="M3 20v-1a6 6 0 0 1 12 0v1"/>
          <path d="M14 20v-1a4 4 0 0 1 7 0v1"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="momBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#401b27"/>
              <stop offset="1" stop-color="#100910"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#momBg)"/>

          <circle cx="130" cy="39"
                  r="18"
                  fill="#9e654e"
                  stroke="#ff1493"/>

          <path d="M98 112
                   c3-43 14-59 32-59
                   s29 16 32 59"
                fill="#873d54"
                stroke="#ff1493"
                stroke-width="2"/>

          <circle cx="178" cy="62"
                  r="13"
                  fill="#ad7358"
                  stroke="#ff1493"/>

          <path d="M155 116
                   c2-30 10-40 23-40
                   s22 10 25 40"
                fill="#5c4d68"
                stroke="#ff1493"
                stroke-width="2"/>

          <path d="M112 31c5-17 30-18 37 1"
                fill="none"
                stroke="#3a2020"
                stroke-width="9"/>

        </svg>
      `
    },

    {
      title: 'EMERGENCY HEALTH SUPPORT',
      description: 'Assistance for eligible participating members experiencing qualifying unexpected health-related expenses or financial hardship resulting from a health emergency.',
      amount: 'UP TO $500',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M12 21s-8-4.5-8-10a4.5 4.5 0 0 1 8-2.7A4.5 4.5 0 0 1 20 11c0 5.5-8 10-8 10Z"/>
          <path d="M12 8v6"/>
          <path d="M9 11h6"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <radialGradient id="healthGlow">
              <stop offset="0" stop-color="#7389a5"/>
              <stop offset="1" stop-color="#0b0c12"/>
            </radialGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="#090a10"/>

          <ellipse cx="150"
                   cy="65"
                   rx="90"
                   ry="45"
                   fill="url(#healthGlow)"
                   opacity=".65"/>

          <path d="M90 34v30
                   c0 25 17 38 35 38
                   s35-13 35-38V34"
                fill="none"
                stroke="#d7e1e8"
                stroke-width="7"/>

          <circle cx="90" cy="32"
                  r="8"
                  fill="#242b35"
                  stroke="#d7e1e8"
                  stroke-width="3"/>

          <circle cx="160" cy="32"
                  r="8"
                  fill="#242b35"
                  stroke="#d7e1e8"
                  stroke-width="3"/>

          <path d="M160 99c15 0 25-7 25-20"
                fill="none"
                stroke="#d7e1e8"
                stroke-width="7"/>

          <circle cx="185" cy="79"
                  r="11"
                  fill="#1a2028"
                  stroke="#ff1493"
                  stroke-width="2"/>

        </svg>
      `
    },

    {
      title: 'DAY CARE SUPPORT',
      description: 'Assistance designed to help eligible parents and guardians with qualifying child care and day care expenses.',
      amount: 'UP TO $500',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <circle cx="8" cy="8" r="3"/>
          <circle cx="16" cy="8" r="3"/>
          <path d="M2 20v-1a5 5 0 0 1 10 0v1"/>
          <path d="M12 20v-1a5 5 0 0 1 10 0v1"/>
            </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="dayBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#3b1b28"/>
              <stop offset="1" stop-color="#0b080e"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#dayBg)"/>

          <path d="M0 96h300v24H0Z"
                fill="#3b2730"/>

          <circle cx="105" cy="45"
                  r="15"
                  fill="#b87557"
                  stroke="#ff1493"/>

          <circle cx="165" cy="50"
                  r="14"
                  fill="#9f654e"
                  stroke="#ff1493"/>

          <circle cx="220" cy="45"
                  r="15"
                  fill="#c18461"
                  stroke="#ff1493"/>

          <path d="M82 110
                   c2-30 10-43 23-43
                   s22 13 24 43"
                fill="#714d75"
                stroke="#ff1493"/>

          <path d="M145 110
                   c2-28 9-39 20-39
                   s19 11 21 39"
                fill="#3e6079"
                stroke="#ff1493"/>

          <path d="M197 110
                   c2-30 10-43 23-43
                   s21 13 23 43"
                fill="#d17647"
                stroke="#ff1493"/>

          <circle cx="150"
                  cy="87"
                  r="9"
                  fill="#ff1493"
                  opacity=".8"/>

        </svg>
      `
    },

    {
      title: 'VISA CARD ASSISTANCE',
      description: 'Eligible participating members may have opportunities to receive prepaid assistance for qualifying everyday needs.',
      amount: 'UP TO $200',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <rect x="3" y="6" width="18" height="12" rx="2"/>
          <path d="M3 10h18"/>
          <path d="M7 14h4"/>
            </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="visaBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#171728"/>
              <stop offset="1" stop-color="#07070c"/>
            </linearGradient>

            <linearGradient id="cardGrad"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#393321"/>
              <stop offset=".45" stop-color="#0e1017"/>
              <stop offset="1" stop-color="#201d2c"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#visaBg)"/>

          <rect x="55"
                y="25"
                width="190"
                height="78"
                rx="8"
                fill="url(#cardGrad)"
                stroke="#ff1493"
                stroke-width="2"/>

          <rect x="70"
                y="42"
                width="27"
                height="20"
                rx="3"
                fill="#c9a74b"/>

          <path d="M74 47h19M74 53h19"
                stroke="#806b2d"
                stroke-width="2"/>

          <circle cx="213"
                  cy="45"
                  r="10"
                  fill="#bd303d"
                  opacity=".8"/>

          <circle cx="223"
                  cy="45"
                  r="10"
                  fill="#f0a51c"
                  opacity=".65"/>

          <text x="73"
                y="83"
                fill="#d9d4df"
                font-size="8"
                font-family="Arial">
            4000 1234 5678 9010
          </text>

          <text x="193"
                y="94"
                fill="#fff"
                font-size="10"
                font-family="Arial"
                font-weight="bold">
            VISA
          </text>

        </svg>
      `
    },

    {
      title: 'EMERGENCY ASSISTANCE',
      description: 'Support for qualifying unexpected circumstances where additional assistance can make a meaningful difference.',
      amount: 'UP TO $1,000',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"/>
          <path d="M12 9v4"/>
          <path d="M12 17h.01"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <radialGradient id="emergGlow">
              <stop offset="0" stop-color="#ff8fb8"/>
              <stop offset="1" stop-color="#170910"/>
            </radialGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="#0d0710"/>

          <ellipse cx="150"
                   cy="66"
                   rx="95"
                   ry="46"
                   fill="url(#emergGlow)"
                   opacity=".55"/>

          <path d="M150 26 200 100H100Z"
                fill="#22131d"
                stroke="#ff1493"
                stroke-width="2.5"/>

          <path d="M150 55v22"
                stroke="#ff1493"
                stroke-width="4"
                stroke-linecap="round"/>

          <circle cx="150" cy="88"
                  r="2.6"
                  fill="#ff1493"/>

        </svg>
      `
    },

    {
      title: 'AND MORE',
      description: 'As the UMYO Gossip ecosystem grows, additional community assistance categories and opportunities may be introduced.',
      amount: 'ONGOING',

      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">
          <circle cx="12" cy="12" r="9"/>
          <path d="M12 8v8"/>
          <path d="M8 12h8"/>
        </svg>
      `,

      illustration: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 300 120">

          <defs>
            <linearGradient id="moreBg"
                            x1="0" y1="0"
                            x2="1" y2="1">
              <stop offset="0" stop-color="#2a1330"/>
              <stop offset="1" stop-color="#08060c"/>
            </linearGradient>
          </defs>

          <rect width="300"
                height="120"
                fill="url(#moreBg)"/>

          <circle cx="120" cy="60" r="26"
                  fill="none"
                  stroke="#ff1493"
                  stroke-width="2"
                  stroke-dasharray="5 6"/>

          <circle cx="180" cy="60" r="14"
                  fill="none"
                  stroke="#ff4fab"
                  stroke-width="2"
                  stroke-dasharray="4 5"/>

          <path d="M110 60h20M120 50v20"
                stroke="#ff1493"
                stroke-width="3"
                stroke-linecap="round"/>

        </svg>
      `
    }
  ];

  steps = [
    {
      number: 1,
      title: 'JOIN THE COMMUNITY',
      description: 'Register and become a participating member of the UMYO Gossip ecosystem.',
      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">

          <circle cx="12" cy="7" r="4"/>
          <path d="M4 21v-1a6 6 0 0 1 12 0v1"/>
          <path d="M19 14v6"/>
          <path d="M16 17h6"/>

        </svg>
      `
    },
    {
      number: 2,
      title: 'STAY ACTIVE',
      description: 'Connect, participate, support businesses, invite others, and help strengthen the community.',
      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">

          <circle cx="8" cy="8" r="3"/>
          <circle cx="16" cy="8" r="3"/>
          <path d="M2 20v-1a5 5 0 0 1 10 0v1"/>
          <path d="M12 20v-1a5 5 0 0 1 10 0v1"/>

        </svg>
      `
    },
    {
      number: 3,
      title: 'WE GROW TOGETHER',
      description: 'As membership participation and ecosystem revenue increase, our ability to fund community assistance can increase.',
      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">

          <path d="M20.8 8.8a5 5 0 0 0-8.8-3.2
                   5 5 0 0 0-8.8 3.2
                   c0 5 8.8 10 8.8 10s8.8-5 8.8-10Z"/>

          <path d="M12 7v5"/>
          <path d="M9.5 9.5 12 12l2.5-2.5"/>

        </svg>
      `
    },
    {
      number: 4,
      title: 'APPLY WHEN PROGRAMS ARE AVAILABLE',
      description: 'Eligible participating members can apply for available hardship incentive programs according to the requirements established for each program.',
      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">

          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/>
          <path d="M14 2v6h6"/>
          <path d="m9 15 2 2 4-4"/>

        </svg>
      `
    },
    {
      number: 5,
      title: 'COMMUNITY SUPPORT IS DISTRIBUTED',
      description: 'Approved assistance is provided according to available funding, eligibility requirements, program rules, and applicable limits.',
      icon: `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.8"
             stroke-linecap="round"
             stroke-linejoin="round">

          <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>

        </svg>
      `
    }
  ];

  constructor(private sanitizer: DomSanitizer) {}

  safeSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
